import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ErrorMessage from 'components/application/ErrorMessage';
import TextField from 'components/application/TextField';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useBreadBoard } from 'components/contexts/Toaster';
import SelectDivision from 'components/teams/SelectDivision';
import SelectedMembersList from 'components/teams/SelectedMembersList';
import SelectMembers from 'components/teams/SelectMembers';

export default function TeamsForm({
  isFetchingTeamMembers,
  onTeamCompanyOptionChange,
  onTeamMemberDelete,
  onTeamMemberSelect,
  onTeamMemberStatusChange,
  onTeamNameInputChange,
  removeErrorStyling,
  requestError,
  sidePanelContext,
  sidePanelFieldRef,
  team,
  teamMembers,
}) {
  const breadBoard = useBreadBoard();
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'teams.TeamsForm',
  });

  const { t: i18nTTeams } = useTranslation('common', {
    keyPrefix: 'teams',
  });

  const [assignableCompanies, setAssignableCompanies] = useState({
    loaded: false,
    collection: [],
  });

  function fetchAssignableCompanies() {
    axios
      .get('/companies')
      .then((response) => {
        setAssignableCompanies({
          loaded: true,
          collection: response.data.data,
        });
      })
      .catch(breadBoard.addInedibleToast);
  }

  useEffect(() => {
    fetchAssignableCompanies();
  }, []);

  return (
    <div className='popup__body-form'>
      <ErrorMessage
        isFallback={requestError.isFallback}
        validationErrors={requestError.validationErrors}
        wrapperClassName='form-container'
      />
      <div className='form-container-section'>
        <TextField
          fieldError={requestError.validationErrors.name}
          inputRef={sidePanelFieldRef}
          isRequired={true}
          label={i18nT('name.label')}
          name='name'
          onChange={onTeamNameInputChange}
          removeErrorStyling={removeErrorStyling}
          value={team.name}
        />
        {assignableCompanies.collection.length > 1 && (
          <>
            <SelectDivision
              assignableCompanies={assignableCompanies.collection}
              onTeamCompanyOptionChange={onTeamCompanyOptionChange}
              sidePanelContext={sidePanelContext}
              team={team}
            />
            {sidePanelContext === 'new' &&
              currentActor.division.attributes.primary && (
                <span className='tw-text-s tw-text-grey-500'>
                  {i18nT('warning')}
                </span>
              )}
          </>
        )}
      </div>
      <hr className='tw-my-8 tw-h-px tw-border-0 tw-bg-grey-100' />
      <div className='form-container-section'>
        <SelectMembers onTeamMemberSelect={onTeamMemberSelect} team={team} />
      </div>
      <div className='popup__body-form tw-mb-8 tw-p-0'>
        <div className='form-container'>
          {isFetchingTeamMembers ?
            <span className='block-list__item tw-border-grey-100'>
              <div className='block-list__item--flex-container'>
                <div className='block-list__item--align-center'>
                  <span>{i18nTTeams('loadingMembers')}</span>
                </div>
              </div>
            </span>
          : <SelectedMembersList
              domainTeamMembers={teamMembers}
              onChange={onTeamMemberStatusChange}
              onTeamMemberDelete={onTeamMemberDelete}
              team={team}
            />
          }
        </div>
      </div>
    </div>
  );
}

TeamsForm.propTypes = {
  team: PropTypes.object.isRequired,
  onTeamNameInputChange: PropTypes.func.isRequired,
  onTeamCompanyOptionChange: PropTypes.func.isRequired,
  onTeamMemberSelect: PropTypes.func.isRequired,
  onTeamMemberStatusChange: PropTypes.func.isRequired,
  onTeamMemberDelete: PropTypes.func.isRequired,
  requestError: PropTypes.object.isRequired,
  removeErrorStyling: PropTypes.func.isRequired,
  sidePanelFieldRef: PropTypes.object.isRequired,
  sidePanelContext: PropTypes.string.isRequired,
  isFetchingTeamMembers: PropTypes.bool.isRequired,
};
